export class RegexPatterns {
  static noSpecialCharacterExcludeHyphenAndPostrophe = /^[0-9A-Za-z\s-']+$/

  static excludedInputCharacters = /[$&+,/:;=?@"<>#%]/
}
